export default angular.module('CrowdsourceApp', [
    'KhBase',
    'leaflet-directive',
    'FiltersData',
    'OilSeedRapeGrowthApp',
    'WheatYellowRustDiseaseApp',
    'CabbageStemFleaApp',
]);
